var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.234 7.04a2.04 2.04 0 1 1-4.078 0 2.04 2.04 0 0 1 4.078 0zm8.287 8.563a4.078 4.078 0 1 0 0-8.156 4.078 4.078 0 0 0 0 8.156zm-10.325 8.156H2l10.195-12.235 7.883 9.459 2.443-2.934v8.972h-7.47l2.717-3.263h-5.572zm10.326-5.71v8.972H30l-7.48-8.972z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana);
export default __webpack_public_path__ + "static/media/MANA.16564b281fbde6db35adc3a28f482a4c.svg";
export { ForwardRef as ReactComponent };